import * as React from 'react';

const Form = ({ w, h, color = 'black', ...props }) => (
  <svg
    width={w}
    height={h}
    {...props}
    fill="none"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.5" y="1.5" width="47" height="47" rx="6.5" stroke="black" strokeWidth="3" />
    <mask id="path-2-inside-1_209_70" fill="white">
      <rect x="21" y="9" width="20" height="10" rx="2" />
    </mask>
    <rect
      x="21"
      y="9"
      width="20"
      height="10"
      rx="2"
      stroke="black"
      strokeWidth="6"
      mask="url(#path-2-inside-1_209_70)"
    />
    <mask id="path-3-inside-2_209_70" fill="white">
      <rect x="21" y="23" width="20" height="10" rx="2" />
    </mask>
    <rect
      x="21"
      y="23"
      width="20"
      height="10"
      rx="2"
      stroke="black"
      strokeWidth="6"
      mask="url(#path-3-inside-2_209_70)"
    />
    <path d="M16 39.5H41" stroke="black" strokeWidth="3" strokeLinecap="round" />
    <path d="M10 13H15" stroke="black" strokeWidth="4" strokeLinecap="round" />
    <path d="M10 27H15" stroke="black" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export default Form;
